import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, useTheme, TextField } from '@mui/material';
import { Booking } from '../../../models/booking';
import { updateBookingField } from '../../../services/BookingService';
import '../../../../styles/commonStyle.css';
import CustomHeader from "../common/CustomHeader"

interface AdditionalDetailsProps {
  booking: Booking;
}

const AdditionalDetailsCard: React.FC<AdditionalDetailsProps> = ({ booking }) => {
  const theme = useTheme();

  const [textValue, setTextValue] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    if (booking.ride?.commentByCustomer && booking.ride.commentByCustomer !== 'NA') {
      setTextValue(booking.ride.commentByCustomer);
    } else {
      setTextValue('');
    }
  }, [booking.ride?.commentByCustomer]);

  const handleSave = async () => {
    await updateBookingField(booking._id, 'commentByCustomer', textValue);
    setDialogOpen(false);
    setOpenSnackbar(true);
  };

  return (
    <>
      {/* Card */}
      <div className="bg-white border rounded shadow-sm p-4 text-start"
        style={{ fontFamily: 'Segoe UI, sans-serif', }}
      >
        <div className="fw-bold mb-0" style={{ fontSize: '1.1rem', color: '#2c3e50' }}>
          Additional Ride Details
        </div>

        <div style={{ color: '#495057', whiteSpace: 'pre-wrap' }}>
          {textValue ? (textValue) : (
            <span className="text-secondary">No additional details provided.</span>
          )}
        </div>

        <button className="btn btn-outline-success btn-sm mt-3"
          onClick={() => setDialogOpen(true)}
        >
          {textValue ? 'Edit Details' : 'Add Details'}
        </button>
      </div>

      {/* Bootstrap Modal */}
      {dialogOpen && (
        <div className="modal fade show"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title">Additional Ride Details</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDialogOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  autoFocus
                  margin="dense"
                  placeholder="Add extra details (e.g. Address Details, passenger name, passenger phone, extra pickup, waiting, or need for a carrier)"
                  value={textValue}
                  onChange={(e) => setTextValue(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setDialogOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className="customSnackbar"
        aria-live="assertive"
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Details saved successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export default AdditionalDetailsCard;
